// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Bhpu8","inner":"Footer_inner__2QB3c","nextIcon":"Footer_nextIcon__3HakS","innerLeft":"Footer_innerLeft__2Ejk0"};